import TermsConditionalsPage from './TermsConditionalsPage';

export default TermsConditionalsPage;